<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow" style="min-width: 1000px">

    <el-form :model="form" label-width="110px" @submit.native.prevent style="max-width: 1430px;">


      <el-form-item label="類型">
        <el-select v-model="definedType" placeholder="請選擇">
          <el-option label="固定金額折扣" value="固定金額折扣"></el-option>
          <el-option label="指定商品折扣" value="指定商品折扣"></el-option>
          <el-option label="百分比折扣" value="百分比折扣"></el-option>
        </el-select>
      </el-form-item>

      <hr/>

      <el-form-item label="活動名稱(中文)">
        <el-input v-model="form.NameTw"></el-input>
      </el-form-item>
      <el-form-item label="活動名稱(英文)">
        <el-input v-model="form.NameEn"></el-input>
      </el-form-item>
      <el-form-item label="活動名稱(日文)">
        <el-input v-model="form.NameJp"></el-input>
      </el-form-item>
      <el-form-item label="數量">
        <el-input v-model="form.Count" type="number" min="0" step="1"></el-input>
        <p class="hint">0或留空則代表沒有兌換數量上限</p>
      </el-form-item>
      <el-form-item label="折扣代碼">
        <el-input v-model="form.Code"></el-input>
      </el-form-item>
      <!-- for 指定商品/固定金額 -->
      <el-form-item label="折扣金額" v-if="definedType!='百分比折扣'">
        <el-input v-model="form.Value" type="number" min="0" step="1"></el-input>
      </el-form-item>
      <!-- for 百分比折扣 -->
      <el-form-item label="折扣百分比" v-if="definedType=='百分比折扣'">
        <el-input v-model="form.Value" type="number" min="0" max="99" step="1" style="width: 170px">
          <template slot="append">% OFF</template>
        </el-input>
        享{{percentageOffChinese}}折優惠
      </el-form-item>
      <el-form-item label="開始時間">
        <el-date-picker v-model="form.BeginAt" class="left" type="datetime" placeholder="選擇日期" style="width: 200px;"></el-date-picker>
        <label class="el-form-item__label" style="width: 80px;">結束時間</label>
        <el-date-picker v-model="form.EndAt" class="left" type="datetime" placeholder="選擇日期" style="width: 200px;"></el-date-picker>
      </el-form-item>
      <!-- for 指定商品折扣 -->
      <el-form-item label="指定商品" v-show="definedType=='指定商品折扣'">
        <el-select style="width: 100%;" filterable v-model="form.ProductIDs" :multiple="true" placeholder="請選擇商品">
          <template slot="empty">
            <p class="el-select-dropdown__empty">沒有資料</p>
          </template>
          <el-option
            v-for="item in activeProducts"
            :key="item.ID"
            :label="item.Tw.Name"
            :value="item.ID">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- for 固定金額 -->
      <el-form-item label="最低購買金額">
        <el-input v-model="form.OrderAmount"></el-input>
      </el-form-item>

      <el-form-item label="狀態">
        <el-switch
          v-model="form.PublishStatus"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import DataApp from '../app.js'
const dataApp = new DataApp()

const CouponTypeReachAmount = 1
const CouponTypeProduct = 2

const DiscountTypeAmount = 1
const DiscountTypePercentage = 2

const PublishStatusPublished = 1
const PublishStatusOff = 2

export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        Code: '',
        NameTw: '',
        NameEn: '',
        NameJp: '',
        CouponType: CouponTypeReachAmount,
        DiscountType: DiscountTypeAmount,
        BeginAt: null,
        EndAt: null,
        Count: 0,
        Used: 0,
        Value: 0,
        OrderAmount: 0,
        ProductIDs: [],
        PublishStatus: PublishStatusPublished,
        IsActive: true,
      },
      defaultForm: {
        Code: '',
        NameTw: '',
        NameEn: '',
        NameJp: '',
        CouponType: CouponTypeReachAmount,
        DiscountType: DiscountTypeAmount,
        BeginAt: null,
        EndAt: null,
        Count: 0,
        Used: 0,
        Value: 0,
        OrderAmount: 0,
        ProductIDs: [],
        PublishStatus: PublishStatusPublished,
      },
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    },
    title () {
      return this.isEdit ? this.oriObj.NameTw : '新增折扣碼'
    },
    definedType: {
      get() {
        return dataApp.definedType(this.form)
      },
      set(value) {
        switch(value) {
          case '固定金額折扣':
            this.form.CouponType = CouponTypeReachAmount
            this.form.DiscountType = DiscountTypeAmount
            break
          case '指定商品折扣':
            this.form.CouponType = CouponTypeProduct
            this.form.DiscountType = DiscountTypeAmount
            break
          case '百分比折扣':
            this.form.CouponType = CouponTypeReachAmount
            this.form.DiscountType = DiscountTypePercentage
            break
          default: //固定金額折扣
            this.form.CouponType = CouponTypeReachAmount
            this.form.DiscountType = DiscountTypeAmount
            break
        }
      },
    },
    percentageOffChinese() {
      if (this.form.Value >= 100) return 0
      if (this.form.Value <= 0) return 10
      let number = 100 - this.form.Value
      if (number%10 == 0) return number/10
      return number
    },
    activeProducts () {
      return this.$store.state.product.list.filter(o => o.IsActive && !o.TeamBuyingID)
    },
  },
  methods: {
    // for base
    setLoading(key, isLoading) {
      this.isLoading = isLoading
    },
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) return

      this.form.Count = parseInt(this.form.Count) || 0
      this.form.OrderAmount = parseInt(this.form.OrderAmount) || 0
      this.form.Value = parseInt(this.form.Value) || 0

      let promise = this.isEdit
        ? this.$services.coupon.edit(this, this.form.ID, this.form)
        : this.$services.coupon.add(this, this.form)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { Weight: 0, IsActive: true }
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.coupon.list.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.coupon.list.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.coupon.list.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown coupon for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.NameTw) errMsg = '請輸入繁中名稱'
      else if (!this.form.NameEn) errMsg = '請輸入英文名稱'
      else if (!this.form.NameJp) errMsg = '請輸入日文名稱'
      else if (this.form.Count < 0 && this.form.Count != '') errMsg = '數量不可以小於0'
      else if (!this.form.Code) errMsg = '請輸入折扣碼'
      else if (!this.form.Value) errMsg = '請輸入折扣金額/百分比'
      else if (parseInt(this.form.Value)<0) errMsg = '折扣金額/百分比不可以是負數'
      else if ((this.form.DiscountType == DiscountTypePercentage) && parseInt(this.form.Value)>=100) errMsg = '百分比不可超過100'
      else if ((this.form.OrderAmount != null && this.form.OrderAmount < 0)) errMsg = '最低購買金額不可以是負數'
      else if ((this.form.CouponType == CouponTypeProduct) && (!this.form.ProductIDs || this.form.ProductIDs.length == 0)) errMsg = '請選擇商品'

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow

    if (
      !this.$store.state.product.isFetched &&
      !this.$store.state.product.isFetching
    ) {
      this.$services.fetchProductDatas(this)//.then(initTableData).catch(this.$handleServiceError)
    }
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = JSON.parse(JSON.stringify(this.defaultForm))
        }
      }
    }
  }
}
</script>
